// third-party
import { FormattedMessage } from 'react-intl';

// assets
import enums from 'utils/enums';
import {
  PersonOutline,
  AccountTreeOutlined,
  ArticleOutlined,
  SyncAltOutlined,
  PhonelinkSetupOutlined,
  NotificationsActiveOutlined,
  Groups2,
  TabletMacOutlined,
  SoupKitchenOutlined,
  AutoAwesomeMotionOutlined
} from '@mui/icons-material';

// icons
const icons = {
  PersonOutline,
  AccountTreeOutlined,
  ArticleOutlined,
  SyncAltOutlined,
  PhonelinkSetupOutlined,
  NotificationsActiveOutlined,
  Groups2,
  TabletMacOutlined,
  SoupKitchenOutlined,
  AutoAwesomeMotionOutlined
};

// ==============================|| MENU ITEMS - MAIN ||============================== //
const admin = {
  id: 'admin',
  type: 'group',
  title: <FormattedMessage id='admin' />,
  roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin],
  children: [
    {
      id: 'employeeList',
      title: <FormattedMessage id='employeeList' />,
      subTitle: 'Manage POS Employees',
      type: 'item',
      url: 'admin/employees',
      icon: icons.Groups2,
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin],
      isShowFilter: true,
      showTitle: true
    },
  ]
};

export default admin;
